document.addEventListener('DOMContentLoaded', function () {
    // Detect iOS and add body class

    if (iOS()) {
        $('body').addClass('ios');
    }

    function iOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    // Inside portal
    const button = document.querySelector('.js-toggle_button');
    const menu = document.querySelector('.js-toggle_menu');

    if (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            button.classList.toggle('is-active');
            menu.classList.toggle('is-active');
        });
    }

    // If window height < sidebar height --> make it scrollable (on desktop)
    if ($(window).width() >= 1100) {
        let windowHeight = $(window).height();
        let sidebarHeight = $('.f-sidebar__container').height();

        if (sidebarHeight > windowHeight) {
            $('.f-sidebar').addClass('f-sidebar--overflow-y-scroll');
        }
    }

    // if ($(window).width() < 768) {
    const $contracts = $('.js-modify_card');

    $contracts.each(function (i) {
        $(this).addClass('wf-card-accent--closed');

        $(this).find('.wf-contract-header').on('click', function (e) {
            if (!$(e.target).hasClass('wf-contract-btn')) {
                $(this).parent().toggleClass('wf-card-accent--closed');
                $(this).parent().toggleClass('wf-card-accent--opened');
            }
        });
    })
    // }

    const $moveAboveTitle = $('.js-move_above_title');

    if ($moveAboveTitle.length) {
        $('.f-content').prepend($moveAboveTitle);
    }

    // Outside portal

    const swiperTarget = document.querySelector('.swiper-container');
    const swiperPagination = document.querySelector('.swiper-pagination');

    if (swiperTarget) {
        const swiper = new Swiper(swiperTarget, {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 320px
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 30
                }
            },
        });
    }

    const $pwShowHide = $('.password-show-hide_1, .password-show-hide_2');

    $pwShowHide.click(function () {
        if ($pwShowHide.find('use').attr('xlink:href') === '#icon-eye-closed') {
            $pwShowHide.find('use').attr('xlink:href', '#icon-eye-opened');
            $pwShowHide.parent().find('input[type="password"]').attr('type', 'text');
            $pwShowHide.find('svg').addClass('password-field-icon--active');
            $pwShowHide.parent().find('input[type="text"]').focus();
        } else {
            $pwShowHide.find('use').attr('xlink:href', '#icon-eye-closed');
            $pwShowHide.parent().find('input[type="text"]').attr('type', 'password');
            $pwShowHide.find('svg').removeClass('password-field-icon--active');
            $pwShowHide.parent().find('input[type="password"]').focus()
        }
    });
});
